export default "/assets/fe3c21c52b5d3405.svg"